var formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR'
});
function currencyLocalesHelper(currencyCode) {
    switch (currencyCode) {
        case 'INR':
            return {
                locale: 'en-IN',
                formatOptions: {
                    style: 'currency',
                    currency: currencyCode,
                    useGrouping: true,
                    minimumFractionDigits: 2
                }
            };
        case 'USD':
            return {
                locale: 'en-US',
                formatOptions: {
                    style: 'currency',
                    currency: currencyCode,
                    useGrouping: true,
                    minimumFractionDigits: 2
                }
            };
        case 'COP':
            return {
                locale: 'es-CO',
                formatOptions: {
                    style: 'currency',
                    currency: currencyCode,
                    useGrouping: true,
                    minimumFractionDigits: 0
                }
            };
        case 'CLP':
            return {
                locale: 'es-CL',
                formatOptions: {
                    style: 'currency',
                    currency: currencyCode,
                    useGrouping: true,
                    minimumFractionDigits: 0
                }
            };
        default:
            return {
                locale: 'en-US',
                formatOptions: {
                    style: 'currency',
                    currency: currencyCode,
                    useGrouping: true,
                    minimumFractionDigits: 2
                }
            };
    }
}
var CurrencyUtil = /** @class */ (function () {
    function CurrencyUtil() {
    }
    /**
     * creates an instance currencyFormatter with provided currency
     * if no currency is provided, defaults to INR
     *
     * @param {string} currency
     */
    CurrencyUtil.setCurrency = function (currencyCode) {
        if (currencyCode === void 0) { currencyCode = 'INR'; }
        var _a = currencyLocalesHelper(currencyCode), locale = _a.locale, formatOptions = _a.formatOptions;
        formatter = new Intl.NumberFormat(locale, formatOptions);
    };
    /**
     * formats the number to a currency and value
     *
     * @param {number} amount
     * @returns {string} formattedAmount eg($9000)
     */
    CurrencyUtil.format = function (amount) {
        return formatter.format(amount);
    };
    /**
     * returns the currency
     *
     * @returns {string} the currency eg($)
     */
    CurrencyUtil.getCurrencySymbol = function () {
        var _a, _b;
        var currencySymbol = (_b = (_a = formatter
            .formatToParts(0)) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.type === 'currency'; })) === null || _b === void 0 ? void 0 : _b.value;
        return currencySymbol;
    };
    /**
     * formats the number to a localised number
     *
     * @param {number} amount
     * @returns {string} formattedNumber eg(9000.00)
     */
    CurrencyUtil.formatNumericOnly = function (amount) {
        var formattedArray = formatter.formatToParts(amount);
        var formattedInteger = '';
        formattedArray.forEach(function (item) {
            if (item.type !== 'currency' && item.type !== 'literal') {
                formattedInteger += item.value;
            }
        });
        return formattedInteger;
    };
    return CurrencyUtil;
}());

export { CurrencyUtil as default };
//# sourceMappingURL=currency.util.js.map
